import styled from 'styled-components';

export const Wrapper = styled.textarea`
  width: 100%;
  background-color: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  font-family: 'Open Sans';
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  transition: all 0.3s;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.16);
  color: rgba(0, 0, 0, 0.56);
  resize: vertical;
  min-height: 144px;
  min-width: 300px;

  &:focus {
    outline: none;
    border-color: rgba(0, 0, 0, 0.4);
  }

  &::placeholder {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.56);
  }
`;
